import { useState, useRef } from "react";
import { ErrorTost, SuccessTost } from "../../utils/ToastHelper";
import { CircleCheck, CloudUpload, File, X } from "lucide-react";
import { Apirequests } from "../../utils/ApiRequests";

export default function UploadDocuments({ user,setRefresh,close }) {
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [isDragging, setIsDragging] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState(null);
    const [loading, setLoading] = useState({name:"",status:false});
    const fileInputRef = useRef(null);

    // console.log(user,'user')

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            validateAndSetFile(selectedFile);
        }
    };

    const validateAndSetFile = (selectedFile) => {
        const allowedTypes = ['.pdf', '.doc', '.docx'];
        const fileExtension = '.' + selectedFile.name.split('.').pop().toLowerCase();

        if (allowedTypes.includes(fileExtension)) {
            setFile(selectedFile);
            setUploadStatus(null);
        } else {
            setUploadStatus({
                type: 'error',
                message: 'Invalid file type. Please select a PDF, DOC, or DOCX file.'
            });
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile) {
            validateAndSetFile(droppedFile);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            setUploadStatus({
                type: 'error',
                message: 'Please select a file first!'
            });
            return;
        }

        if (!fileName.trim()) {
            setUploadStatus({
                type: 'error',
                message: 'Please enter a file name!'
            });
            return;
        }

        setLoading({name:"uploaddoc",status:true})

        const formData = new FormData();
        formData.append("document", file);
        formData.append("file_name", fileName);

        try {
            setUploadProgress(0);

            const uploadres = await fetch(`${process.env.REACT_APP_SERVER_URI}image/upload-documents/${user._id}`, {
                method: "POST",
                body: formData
            });

            const response = await uploadres.json();

            // console.log(response);

            if (response.success) {

                SuccessTost(response.message)
                setFile(null);
                setFileName("");
                close();
                setRefresh((prev)=> !prev)
            } else {
                // ErrorTost(response.message)
                setUploadStatus({
                    type: 'error',
                    message: response.message || 'File upload failed!'
                });

            }


        } catch (error) {
            console.error("Upload Error:", error);
            setUploadStatus({
                type: 'error',
                message: 'File upload failed. Please try again.'
            });
        }

        setLoading({name:"",status:false})
    };

    const handleDeleteDocument= async(filename)=>{

        setLoading({name:"deletedoc",status:true})
        try {
            const delRes= await Apirequests(`image/delete-document/${filename}/${user?._id}`,'DELETE',{},{});
            if(delRes.success){
                SuccessTost(delRes?.message);
                close();
                setRefresh((prev)=>!prev)
            }else{
                ErrorTost(delRes?.message)
            }
        } catch (error) {
            ErrorTost(error?.message)
        }

        setLoading({status:false,name:""})
    }

    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Document Upload</h2>

                {uploadStatus && (
                    <div className={`mb-6 p-4 rounded-lg ${uploadStatus.type === 'error'
                        ? 'bg-red-50 text-red-700 border border-red-200'
                        : 'bg-green-50 text-green-700 border border-green-200'
                        }`}>
                        {uploadStatus.message}
                    </div>
                )}

                <div
                    className={`flex flex-col justify-center items-center mb-6 p-8 border-2 border-dashed rounded-lg text-center cursor-pointer transition-colors duration-200 ${isDragging
                        ? 'border-indigo-500 bg-indigo-50'
                        : 'border-gray-300 hover:border-indigo-400'
                        }`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={() => fileInputRef.current?.click()}
                >
                    <CloudUpload />
                    <p className="text-gray-600 mb-2">
                        Drag & drop your document here or{" "}
                        <span className="text-indigo-600">browse</span>
                    </p>
                    <p className="text-sm text-gray-500">
                        Supported formats: PDF, DOC, DOCX
                    </p>
                </div>

                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}
                    className="hidden"
                />

                <div className="mb-6">
                    <label htmlFor="fileName" className="block text-sm font-medium text-gray-700 mb-2">
                        File Name
                    </label>
                    <input
                        type="text"
                        id="fileName"
                        value={fileName}
                        onChange={(e) => setFileName(e.target.value)}
                        placeholder="Enter file name"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                </div>

                {file && (
                    <div className="mb-6 bg-gray-50 rounded-lg p-4 flex items-center justify-between">
                        <div className="flex items-center">
                        <File />                            
                            <span className="text-gray-600">{file.name}</span>
                        </div>
                        <button
                            onClick={() => {
                                setFile(null);
                                if (fileInputRef.current) {
                                    fileInputRef.current.value = '';
                                }
                            }}
                            className="text-red-500 hover:text-red-700"
                        >
                            <X />
                        </button>
                    </div>
                )}

                {uploadProgress > 0 && (
                    <div className="mb-6">
                        <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                            <div
                                className="h-full bg-indigo-600 transition-all duration-300"
                                style={{ width: `${uploadProgress}%` }}
                            />
                        </div>
                        <p className="text-sm text-gray-600 mt-2 text-center">{uploadProgress}% uploaded</p>
                    </div>
                )}

                <div className="text-center">
                    <button
                        onClick={handleUpload}
                        disabled={loading.status && loading.name==="uploaddoc"}
                        className={`px-6 py-2 rounded-lg font-medium ${loading.status && loading.name==="uploaddoc"
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            : 'bg-indigo-600 text-white hover:bg-indigo-700'
                            } transition-colors duration-200`}
                    >
                        {loading.status && loading.name==="uploaddoc" > 0 ? 'loading...' : 'Upload Document'}
                    </button>
                </div>

                {user?.documents?.length > 0 && (
                    <div className="mt-8">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Uploaded Files</h3>
                        <div className="space-y-3">
                            {user?.documents?.map((uploadedFile, index) => (
                                <div
                                    key={index}
                                    className="bg-gray-50 rounded-lg p-4 flex items-center justify-between"
                                >
                                    {/* <div className="flex items-center">
                                    <CircleCheck />
                                        <span className="text-gray-700">{uploadedFile.name}</span>
                                    </div> */}
                                    <a
                                        href={uploadedFile.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-indigo-600 hover:text-indigo-800 font-medium text-sm"
                                    >
                                        {uploadedFile.name}
                                    </a>

                                    <div className="cursor-pointer" onClick={()=>handleDeleteDocument(uploadedFile.originalName)}>
                                        <X/>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}